import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    ElementRef,
    input,
    output,
    viewChild,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { GanttChart, GanttChartOptions } from '../gantt-chart';

@Component({
    selector: 'bucke-gantt-chart-zoom',
    templateUrl: './gantt-chart-zoom.component.html',
    styleUrl: './gantt-chart-zoom.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GanttChartZoomComponent {
    data = input.required<any[]>();
    height = computed(() => (this.data().length > 0 ? 100 + this.data().length * 70 : 0));
    width = input.required<number>();
    dMin = input.required<string>();
    dMax = input.required<string>();
    months = input.required<string[]>();
    chartDiv = viewChild.required<ElementRef<HTMLDivElement>>('chartDiv');

    itemSelect = output<string>();

    private readonly margin = { top: 20, right: 20, bottom: 110, left: 160 };
    private readonly margin2 = { top: 430, right: 20, bottom: 30, left: 160 };

    constructor(private readonly translateService: TranslocoService) {
        effect((onCleanup) => {
            const data = this.data();
            const height = this.height();
            const width = this.width();
            const dMin = this.dMin();
            const dMax = this.dMax();
            const months = this.months();
            const chartElement = this.chartDiv().nativeElement;
            const options = new GanttChartOptions(
                '#chart',
                data,
                height,
                width,
                this.margin,
                this.margin2,
                dMin,
                dMax,
                months,
            );

            chartElement.innerHTML = '';
            new GanttChart(this.translateService, options).build();
            const onSelect = this.onSelect.bind(this);
            chartElement.addEventListener('select', onSelect);
            onCleanup(() => {
                chartElement.removeEventListener('select', onSelect);
            });
        });
    }

    onSelect(event): void {
        this.itemSelect.emit(event.detail);
    }
}
